import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { downloadDocType } from '@lib/util/link-redirection-ops';
import { MuscleButton } from '@modules/shared/components/buttons';
import MuscleCheckbox from '@modules/shared/components/checkbox';
import MuscleCountryInput from '@modules/shared/components/country-input';
import EmailInput from '@modules/shared/components/email-input';
import MuscleFormTextInput from '@modules/shared/components/form-text-input';
import PageContainer from "@modules/layout/components/shared/container";
import PasswordInput from '@modules/shared/components/password-input';
import TextWithLinks from '@modules/shared/components/text-with-links';
import Icons from '@modules/icons';
import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';
import { DocumentType } from 'types/document-type';
import { concatAllString, isNumericString, separateStringData } from '@lib/util/string-ops';
import SocialMediaAuth from '@modules/shared/auth-flows/flows/social-media-auth';
import { Divider } from '@mui/material';
import PasswordCondition from '../password-condition';
import facebookIntegrationManager from '@lib/data/managers/shared/integrations/implementations/facebook-integration-manager';
import { jwtDecode } from "jwt-decode";
import APP_CONFIGURATION from '@lib/app.config';
import { EMAIL_REGEX } from '@lib/constants';
const DefaultForm = _ref => {
  let {
    info,
    setInfo,
    setIsValid,
    registerType
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const tInputs = useTranslations('Shared.TextInput');

  // Form validation states
  const {
    0: documentIsValid,
    1: setDocumentIsValid
  } = useState(true);

  // Password validation states
  const {
    0: hasAtLeast8Chars,
    1: setHasAtLeast8Chars
  } = useState(false);
  const {
    0: hasAtLeast1Symbol,
    1: setHasAtLeast1Symbol
  } = useState(false);
  const {
    0: hasAtLeast1CapitalLetter,
    1: setHasAtLeast1CapitalLetter
  } = useState(false);
  const {
    0: confirmationMatch,
    1: setConfirmationMatch
  } = useState(false);
  const allowTestEmails = process.env.NEXT_PUBLIC_ALLOW_TEST_EMAILS === "true";
  useEffect(() => {
    const {
      password,
      passwordConfirmation,
      documentNumber
    } = info;
    setHasAtLeast8Chars(registerType === 'provider' || password.length >= 8);
    setHasAtLeast1Symbol(registerType === 'provider' || /(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(password));
    setHasAtLeast1CapitalLetter(registerType === 'provider' || /(?=.*[A-Z])/.test(password));
    setConfirmationMatch(registerType === 'provider' || password === passwordConfirmation && passwordConfirmation.length > 0);
    setDocumentIsValid(isNumericString(documentNumber) && documentNumber.length >= 8 && documentNumber.length <= 15);
    if (documentNumber) {
      setDocumentIsValid(isNumericString(documentNumber) && documentNumber.length >= 8 && documentNumber.length <= 15);
    } else {
      setDocumentIsValid(true);
    }
  }, [info, registerType]);
  useEffect(() => {
    const valid = info.name !== '' && info.lastName !== '' && info.country !== '' && (info.email !== '' || registerType === 'provider') && (info.confirmEmail !== '' || registerType === 'provider') && (info.password !== '' || registerType === 'provider') && (info.passwordConfirmation !== '' || registerType === 'provider') && (info.email === info.confirmEmail && (EMAIL_REGEX.test(info.email) || allowTestEmails) || registerType === 'provider') && info.documentNumber !== '' && (info.password === info.passwordConfirmation || registerType === 'provider') && info.acceptTerms;
    setIsValid(valid && documentIsValid && hasAtLeast8Chars && hasAtLeast1Symbol && hasAtLeast1CapitalLetter && confirmationMatch);
  }, [confirmationMatch, documentIsValid, hasAtLeast1CapitalLetter, hasAtLeast1Symbol, hasAtLeast8Chars, info, registerType, setIsValid]);
  return __jsx(React.Fragment, null, __jsx(MuscleFormTextInput, {
    label: t('NAME'),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      name: value
    })),
    value: info.name,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(MuscleFormTextInput, {
    label: t('LAST_NAME'),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      lastName: value
    })),
    value: info.lastName,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(MuscleFormTextInput, {
    label: t('SECOND_LAST_NAME'),
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      secondLastName: value
    })),
    value: info.secondLastName,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(MuscleCountryInput, {
    label: t('COUNTRY'),
    required: true,
    onChange: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      country: value
    })),
    value: info.country,
    labelClassName: "tx-psm-bold"
  }), __jsx(MuscleFormTextInput, {
    label: t("DOCUMENT_NUMBER"),
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      documentNumber: value
    })),
    value: info.documentNumber,
    mode: "alphanumeric",
    invalidValueMessage: tInputs('INVALID_DOCUMENT_NUMBER'),
    valueIsInvalid: !documentIsValid,
    required: true,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), registerType === 'normal' && __jsx(React.Fragment, null, __jsx("div", {
    className: "flex flex-col md:flex-row gap-8 justify-center"
  }, __jsx(EmailInput, {
    label: t('EMAIL'),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      email: value
    })),
    value: info.email,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(EmailInput, {
    label: t('CONFIRM_EMAIL'),
    value: info.confirmEmail,
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      confirmEmail: value
    })),
    fullLength: true,
    labelClassName: "tx-psm-bold"
  })), __jsx("div", {
    className: "flex flex-col md:flex-row gap-8 justify-center"
  }, __jsx("div", {
    className: "flex flex-col gap-1 w-full"
  }, __jsx(PasswordInput, {
    label: t('PASSWORD'),
    value: info.password,
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      password: value
    })),
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(PasswordCondition, {
    state: hasAtLeast8Chars,
    title: t('AT_LEAST_8_CHARS')
  }), __jsx(PasswordCondition, {
    state: hasAtLeast1Symbol,
    title: t('AT_LEAST_1_SYMBOL')
  }), __jsx(PasswordCondition, {
    state: hasAtLeast1CapitalLetter,
    title: t('AT_LEAST_1_CAPITAL')
  })), __jsx("div", {
    className: "flex flex-col gap-1 w-full"
  }, __jsx(PasswordInput, {
    label: t('CONFIRM_PASSWORD'),
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      passwordConfirmation: value
    })),
    value: info.passwordConfirmation,
    required: true,
    fullLength: true,
    labelClassName: "tx-psm-bold"
  }), __jsx(PasswordCondition, {
    state: confirmationMatch,
    title: t('PASSWORD_CONFIRMATION_MATCH')
  })))), __jsx("br", null), __jsx("div", {
    className: "flex flex-row gap-1 items-center"
  }, __jsx(MuscleCheckbox, {
    value: info.acceptTerms,
    onChange: () => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      acceptTerms: !info.acceptTerms
    }))
  }), __jsx(TextWithLinks, {
    text: t('I_ACCEPT_THE_TERMS_AND_CONDITIONS'),
    linksActions: [() => downloadDocType(DocumentType.TERMS_AND_CONDITIONS)],
    textStyle: "tx-psm-regular",
    linksStyle: "tx-psm-bold"
  })));
};
const MuscleRegistrationScreen = _ref2 => {
  let {
    onSubmit,
    isSubmitting,
    onClickBack,
    title,
    description,
    buttonText
  } = _ref2;
  const t = useTranslations('Shared.Auth');
  const tGeneral = useTranslations('Shared');
  const tInputs = useTranslations('Shared.TextInput');
  const allowSocialMediaAuth = (process.env.NEXT_PUBLIC_SOCIAL_MEDIA_AUTH || 'false') === 'true';
  const {
    0: loading,
    1: setLoading
  } = useState(false);
  const {
    0: providerAuth,
    1: setProviderAuth
  } = useState(null);
  const {
    0: info,
    1: setInfo
  } = useState({
    name: '',
    lastName: '',
    secondLastName: '',
    country: '',
    email: '',
    confirmEmail: '',
    password: '',
    passwordConfirmation: '',
    acceptTerms: false,
    documentNumber: ''
  });
  const {
    0: isValid,
    1: setIsValid
  } = useState(false);
  const finishRegistration = async () => {
    if (providerAuth) {
      onSubmit({
        first_name: info.name,
        last_name: concatAllString(' ', info.lastName, info.secondLastName),
        country: info.country,
        identification_number: info.documentNumber,
        provider_token: providerAuth === null || providerAuth === void 0 ? void 0 : providerAuth.provider_token,
        provider_id: providerAuth === null || providerAuth === void 0 ? void 0 : providerAuth.provider_id
      });
    } else {
      onSubmit({
        first_name: info.name,
        last_name: concatAllString(' ', info.lastName, info.secondLastName),
        country: info.country,
        email: info.email,
        password: info.password,
        password_confirmation: info.passwordConfirmation,
        identification_number: info.documentNumber
      });
    }
  };
  return __jsx(PageContainer, null, onClickBack ? __jsx(React.Fragment, null, __jsx(MuscleButton, {
    onClick: () => onClickBack(),
    variant: "link"
  }, __jsx(Icons.arrowLeft, null), t('BACK'))) : null, __jsx("div", {
    className: "max-w-[470px] w-full self-center flex flex-col gap-3 pb-[120px]"
  }, __jsx("div", {
    className: "flex flex-col gap-4 text-center text-black "
  }, __jsx("div", {
    className: "flex flex-row items-center justify-center gap-2"
  }, __jsx(Icons.circleCheck, {
    size: 20,
    color: APP_CONFIGURATION.colors.success_main
  }), __jsx("div", {
    className: "text-primary-main tx-plg-bold"
  }, title)), __jsx("div", {
    className: "tx-psm-light"
  }, description), allowSocialMediaAuth && !providerAuth && __jsx(React.Fragment, null, __jsx(SocialMediaAuth, {
    type: "register",
    loading: loading,
    className: "gap-8",
    setLoading: setLoading,
    successCallback: async (token, provider) => {
      switch (provider) {
        case 'google':
          {
            const profile = jwtDecode(token);
            setInfo(_objectSpread(_objectSpread({}, info), {}, {
              password: '',
              passwordConfirmation: '',
              name: profile.given_name,
              lastName: separateStringData(profile.family_name, true, ' '),
              secondLastName: separateStringData(profile.family_name, false, ' '),
              email: profile.email
            }));
          }
          break;
        case 'facebook':
          {
            const profile = await facebookIntegrationManager.getProfile();
            setInfo(_objectSpread(_objectSpread({}, info), {}, {
              password: '',
              passwordConfirmation: '',
              name: profile.first_name,
              lastName: separateStringData(profile.last_name, true, ' '),
              secondLastName: separateStringData(profile.last_name, false, ' ')
            }));
          }
          break;
      }
      setProviderAuth({
        provider_token: token,
        provider_id: provider
      });
    }
  }), __jsx(Divider, null, __jsx("span", {
    className: "text-neutral-400"
  }, tGeneral('OR'))))), __jsx(DefaultForm, {
    info: info,
    setInfo: setInfo,
    setIsValid: setIsValid,
    registerType: providerAuth ? 'provider' : 'normal'
  }), __jsx("br", null), __jsx("div", {
    className: "flex w-full items-center justify-center"
  }, __jsx(MuscleButton, {
    text: buttonText,
    disabled: !isValid || loading,
    onClick: () => finishRegistration(),
    isLoading: isSubmitting || loading
  }))));
};
export default MuscleRegistrationScreen;